import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { IoHome } from "react-icons/io5";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text className="project-description">
            {props.description}
        </Card.Text>
        <div className="btn-container">
            <Button variant="primary" href={props.homePageLink} target="_blank">
            <IoHome /> &nbsp;
            {props.isHomePage ? "Dashboard" : "GitHub"}
            </Button>
            {props.demoLink && (
            <Button
                variant="primary"
                href={props.demoLink}
                target="_blank"
            >
                <CgWebsite /> &nbsp;
                {"Demo"}
            </Button>
            )}
        </div>
        </Card.Body>
    </Card>
  );
}
export default ProjectCards;
